<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getDepartmentInfo
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					
					
					
					
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
						
						
						
						getDepartmentInfo(depart.id).then(async res => {
							var departFullName = res.Body.FullName;
							var departName = departFullName.split("/");
							var jzspValue=[];
							
							that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
								if (item.Property.Title[0].Text == "逐级审批使用") {
									if(departName.indexOf("住宅部") > -1&&departName.indexOf("东南区") == -1){
										item.Values = await that.getDepartmentRelationList(depart.id, 10);
										item.Values.splice(item.Values.length-1,1);
									}else{
										item.Values = await that.getDepartmentRelationList(depart.id, 8,'住宅部');
									}
									if (item.Values == null || item.Values.length <= 0) {
										item.Values.push(that.$store.state.defaultMember);
									}
									}
							})
							})
					}
				})
			},
			getTemplate:async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var departs = this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;
				
				
				await this.getEmployeeRelation(this.logInfo.EmpNo);
				
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					var that=this;
					controls.TemplateContent.Controls.forEach(async (item) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "确认申请信息是否正确") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经办是否报集团审批") {
							item.IsShow = false;
						}
						// if (item.Property.Title[0].Text == "申请部门") {
						//      if(departs.indexOf("住宅部")>-1){
						//      	item.Property.Title[0].Text="申请部门(分行名称)";
						//      }
						// }
						if (item.Property.Title[0].Text == "所属区域(选到小战区)") {
							item.IsShow = false;
							if(departs.indexOf("住宅部")>-1){
								item.IsShow = true;
							}else{
								item.Values = [["16548","保利梧桐语(钱是君)分行"]]
							}
						}
						if (item.Property.Title[0].Text == "发票类型") {
							item.IsShow = false;
						}
						if (item.Property.Id == "Tips-1600410181849") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values = [];
							//item.Values.push(that.$store.state.defaultMember);
							item.Values = this.getRelationList(this.relationList, 10);
							if(departs.indexOf("华西区信息中心")==-1){
								if (item.Values == null || item.Values.length <= 0) {
									//审批节点无人，跳过
									item.Values.push(that.$store.state.defaultMember);
								}
								var isFind=true;
								item.Values.forEach(t=>{
									if(t[0]==that.$store.state.defaultMember[0]){
										isFind=false;
									}
								})
								if(isFind){
									item.Values.push(that.$store.state.defaultMember);
								}
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "附开票信息") {
							item.Value = "名称：四川中原物业顾问有限公司纳税人识别号：91510100740324828J\n" +
								"地址、电话：四川省成都市锦江区大业路6号青石桥南街财富中心一栋3单元24层 028-86766488\n" +
								"开户行及账号：建行岷江支行       51001860836050141086";
							item.IsShow = false;
						}
						
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
				
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0]
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+" "+control1.Value+"  "+this.logInfo.EmpNo+"  "+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control4.Values[0][1],"Lang":"zh_CN"});
				SummaryList.push(info);
				var control5=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "房租借支金额"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"房租借支金额："+control5.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList
				this.templateData.TemplateContent.Controls.forEach(item=>{
					if (item.Property.Title[0].Text == "确认申请信息是否正确") {
						item.IsShow = true;
					}
					if (item.Property.Title[0].Text == "总经办是否报集团审批") {
						item.IsShow = true;
					}
					if (item.Property.Title[0].Text == "发票类型") {
						item.IsShow = true;
					}
					if (item.Property.Title[0].Text == "附开票信息") {
						item.IsShow = true;
					}
				});
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}
		
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
